module.exports = __webpack_public_path__ + "static/media/go-to-home.6d2cc900.png";